import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { Tooltip } from 'react-wot-bootstrap'

import { getFormattedTime } from 'helpers/datetime'
import { CANCEL } from 'helpers/i18n'

import {
    CANCEL_TOOLTIP_CONTENT,
    ADD_RESERVE_TO_QUEUE_TITLE,
    CANCEL_TOOLTIP_ID,
} from './constants.jsx'

import styles from './ProductionProgress.scss'

export default class ProductionProgress extends React.Component {
    static propTypes = {
        hasPermission: PropTypes.bool.isRequired,
        reserveQueue: PropTypes.arrayOf(PropTypes.object),
        onCancel: PropTypes.func,
        playHoverSound: PropTypes.func,
        simplified: PropTypes.bool,
    }
    static defaultProps = {
        reserveQueue: [],
        simplified: false,
        hasPermission: false,
    }
    constructor(props) {
        super(props)
        this.handleHover = this.handleHover.bind(this)
    }
    componentWillReceiveProps(nextProps) {
        this.refreshQueue(nextProps.reserveQueue)
    }
    componentWillMount() {
        this.refreshQueue(this.props.reserveQueue)
    }
    componentWillUnmount() {
        this.clearTimeouts()
    }
    handleHover() {
        this.props.playHoverSound()
    }
    refreshQueue(queue) {
        this.clearTimeouts()

        const actualQueue = queue.filter((reserve) => {
            return reserve.productionEnds > Date.now()
        })

        if (actualQueue.length === 0) {
            this.setState({
                actualQueue,
            })
            return
        }

        const [currentReserve, ...rest] = actualQueue

        this.timerId = setTimeout(
            this.refreshQueue.bind(this, rest),
            currentReserve.productionEnds - Date.now()
        )
        this.intervalId = setInterval(this.forceUpdate.bind(this), 1000)

        this.setState({
            actualQueue,
            productionTime: currentReserve.production_time * 1000,
            productionEnds: currentReserve.productionEnds,
            allProductionsEnd: actualQueue[actualQueue.length - 1].productionEnds,
        })
    }
    clearTimeouts() {
        if (this.intervalId) clearInterval(this.intervalId)
        if (this.timerId) clearTimeout(this.timerId)
    }
    isDelayed() {
        return (this.state.productionEnds - Date.now()) > this.state.productionTime
    }
    getAvailabilityPercentage() {
        if (this.isDelayed()) {
            return 0
        }

        const percentage = 100 - (
            (this.state.productionEnds - Date.now() - 1000) / this.state.productionTime
        ) * 100

        return percentage <= 100 ? percentage : 100
    }
    render() {
        if (this.state.actualQueue.length === 0) {
            return null
        }

        let cancelButton
        let cancelButtonTooltip
        if (this.props.hasPermission && !this.props.simplified) {
            cancelButton = (
                <div
                    onClick={this.props.onCancel}
                    onMouseEnter={this.handleHover}
                    className={styles.cancel}
                    data-tip
                    data-for={CANCEL_TOOLTIP_ID}
                />
            )

            cancelButtonTooltip = (
                <Tooltip id={CANCEL_TOOLTIP_ID}>
                    <div className={styles.tooltipContent}>
                        <h3 className={styles.tooltipSubtitle}>{CANCEL}</h3>
                        <p className={styles.tooltipMessage}>{CANCEL_TOOLTIP_CONTENT}</p>
                    </div>
                </Tooltip>
            )
        }

        let title
        if (!this.props.simplified) {
            if (this.props.hasPermission) {
                title = <h3 className={styles.title}>{ADD_RESERVE_TO_QUEUE_TITLE}</h3>
            }
        }

        const componentBody = (
            <div className={styles.grid}>
                <div className={styles.progress}>
                    <div className={styles.holder}>
                        <div className={styles.wrapper}>
                            <div
                                className={styles.bar}
                                style={{ width: `${this.getAvailabilityPercentage()}%` }}
                            >
                            </div>
                        </div>
                    </div>
                    {
                        (!this.props.simplified) ? (
                            <span className={styles.timeLeft}>
                                {this.isDelayed() ? (
                                    getFormattedTime(this.state.productionTime, true)
                                ) : (
                                    getFormattedTime(this.state.productionEnds - Date.now(), true)
                                )}
                            </span>
                        ) : null
                    }
                </div>
                <div className={styles.controls}>
                    <div className={styles.multiplier}>{`\u00D7 ${this.state.actualQueue.length}`}</div>
                    {cancelButton}
                </div>
            </div>
        )

        const className = classNames(styles.base, {
            [styles.base__simplified]: this.props.simplified,
        })

        return (
            <div className={className}>
                {componentBody}
                {cancelButtonTooltip}
                {title}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/ProductionProgress/ProductionProgress.jsx